import React from 'react';
import { Button, Icon } from 'antd';
import styles from './MeterModal.module.scss';

const InfoTitle = ({ onClick, serialNumber }) => {
  return (
    <>
      {`Информация по счетчику${serialNumber}`}
      {typeof onClick === 'function' && (
        <Button className={styles.editBtn} onClick={onClick}>
          <span className="ant-modal-close-x">
            <Icon type="edit" />
          </span>
        </Button>
      )}
    </>
  );
};

export default InfoTitle;
